import { theme } from '@maestro/local/theme'

/**
 * Base URL of the favorites feature for the configured advanced variant:
 * '/shopping-lists' for b2b, '/favorites' for b2c. The b2b path is rewritten
 * to the /favorites routes in next.config, but user-facing URLs (links,
 * share link, redirects) should consistently use the variant terminology.
 */
export function getFavoriteListsUrl(): string {
  const {
    favorites: { favoritesAdvancedVariant },
    urls,
  } = theme()

  return favoritesAdvancedVariant === 'b2b'
    ? urls.shoppingLists
    : urls.favorites
}

export function getFavoriteListUrl(favoriteListId: string): string {
  return `${getFavoriteListsUrl()}/${favoriteListId}`
}
